import React, { useEffect, useState, useRef, useCallback } from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors, Results, useSearch } from "@usereactify/search";
import { SearchForm } from "./search-form";
import { ResultsItem } from "../Results/results-item";
import { SearchFormPopular } from "./search-form-popular";
import { InstantSearchResults } from "../Results/results";

const ReactifySearchFactory = new ReactifySearchLiquidFactory({
  mode: "instant-search",
  shopifyPermanentDomain: "salt-and-pepper-au.myshopify.com",
});

const ReactifySearchProvider = ReactifySearchFactory.getProvider();
const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

const InstantSearch: React.FC = () => {
  const [showInstantSearch, setShowInstantSearch] = useState<boolean>(false);
  const inputRefs = [useRef<HTMLInputElement>(null), useRef<HTMLInputElement>(null)]

  /* getting popular search in header.liquid from a selected menu, then pusing into an array */
  const popularSearchTerms = document.getElementsByClassName(`thb-quick-search--popular`);
  let popularTermArr = [];
  for (let i = 0; i < popularSearchTerms.length; ++i) {
    popularTermArr.push(popularSearchTerms[i].innerHTML);
  }
  const { searchTerm, setSearchTerm, submitSearchTerm } = useSearch();
  const handleSearch = React.useCallback(() => {
    submitSearchTerm(searchTerm);
  }, [submitSearchTerm, searchTerm]);

  const submitSearchKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      handleSearch();
    } else if (event.keyCode === 27) {
      setShowInstantSearch(false);
    }
  };

  const handleClear = useCallback((index: number) => {
    inputRefs[index].current?.focus();

    setSearchTerm("");
  }, [])

  return (
    <>
      <div
        className="thb-secondary-item qs-nav qs-nav-desktop"
        id="quick-search"
        title="Search"
        onClick={() => setShowInstantSearch(true)}
      >
        <label class="screen-reader-shortcut" for="Site-search">Search</label>
        <svg width="58" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.1667 29.9583C26.4699 29.9583 29.9583 26.4699 29.9583 22.1667C29.9583 17.8634 26.4699 14.375 22.1667 14.375C17.8634 14.375 14.375 17.8634 14.375 22.1667C14.375 26.4699 17.8634 29.9583 22.1667 29.9583Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M32.2503 32.2498L27.667 27.6665"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        {/* <span className="qs-placeholder">Search products, ranges &amp; brands...</span> */}
        <input
          type="search"
          ref={inputRefs[0]}
          className="qs-placeholder"
          placeholder="Search for anything"
          id="Site-search"
          name="q"
          onKeyDown={(e) => submitSearchKey(e)}
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
        <div
          onClick={() => handleClear(0)}
          className={`clear-qs fs-small ${searchTerm === "" && "clear-qs--hidden"}`}
        >
          Clear
        </div>
      </div>
      <div
        className="thb-secondary-item qs-nav qs-nav-mobile"
        id="quick-search"
        title="Search"
        onClick={() => setShowInstantSearch(true)}
      >
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.1667 29.9583C26.4699 29.9583 29.9583 26.4699 29.9583 22.1667C29.9583 17.8634 26.4699 14.375 22.1667 14.375C17.8634 14.375 14.375 17.8634 14.375 22.1667C14.375 26.4699 17.8634 29.9583 22.1667 29.9583Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M32.2503 32.2498L27.667 27.6665"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
        {/* <span className="qs-placeholder">Search products, ranges &amp; brands...</span> */}
        <input
          type="search"
          ref={inputRefs[1]}
          className="qs-placeholder"
          placeholder="Search for anything"
          name="q"
          onKeyDown={(e) => submitSearchKey(e)}
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
        <div
          onClick={() => handleClear(1)}
          className={`clear-qs fs-small ${searchTerm === "" && "clear-qs--hidden"}`}
        >
          Clear
        </div>
      </div>
      <div
        className="thb-quick-search"
        style={{
          display: showInstantSearch ? "block" : "none",
        }}
      >
        {/* <div className="thb-quick-search--form">
          <SearchForm setShowInstantSearch={setShowInstantSearch} />
        </div> */}
        <div>
          <InstantSearchResults />
        </div>
        {searchTerm&&<div className="thb-quick-search--view-all">
          <button className="chip" onClick={handleSearch}>View all results</button>
        </div>}
        
        <SearchFormPopular popularTermArr={popularTermArr} />
        <div onClick={() => setShowInstantSearch(!showInstantSearch)} id="shadow-background"></div>
      </div>
    </>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <ReactifySearchProvider>
      <Sensors />
      <InstantSearch />
    </ReactifySearchProvider>
  </React.StrictMode>,
  ReactifySearchMountNode
);
